<template>
  <NuxtLayout name="auth">
    <div class="kb-auth-page">
      <div class="kb-auth-head">
        <p class="font-mono !text-[12.5px] !text-kb-dim">
          error {{ props.error?.statusCode ?? '' }}
        </p>
        <h1>{{ errorTitle }}</h1>
        <p>{{ errorMessage }}</p>
      </div>
      <div class="flex flex-wrap gap-2">
        <Button
          label="Go back"
          icon="pi pi-arrow-left"
          outlined
          severity="secondary"
          size="small"
          @click="goBack"
        />
        <Button
          label="Home"
          icon="pi pi-home"
          size="small"
          @click="goHome"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from 'nuxt/app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const errorTitle = computed(() => {
  switch (props.error?.statusCode) {
    case 404: return 'Page not found'
    case 403: return 'Not for you'
    case 500: return 'Something broke'
    default: return 'Something went wrong'
  }
})

useHead({ title: errorTitle })

const errorMessage = computed(() => {
  switch (props.error?.statusCode) {
    case 404:
      return 'That page doesn\'t exist, or it has moved.'
    case 403:
      return 'Your account doesn\'t have access to that page.'
    case 500:
      return 'The server ran into a problem. Try again in a minute.'
    default:
      return props.error?.message || 'Try again in a minute.'
  }
})

// Leave the error state as we go: clearError resets it and navigates
const goHome = () => clearError({ redirect: '/' })

const goBack = () => {
  if (window.history.length > 1) {
    clearError()
    window.history.back()
  }
  else {
    goHome()
  }
}
</script>
